import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from 'fuse-ui/components/Typography';
import SenderList from '../sender-verification/senders-list';
import opacity from '../common/theme/colors/opacity';

const styles = theme => ( {
    senderInfo: {
        marginBottom: `${theme.spacing.unit * 2}px`,
    }
} );

const DomainDetailsSendersTab = ( { classes, domainName, sendersData, onEdit } ) => {
    return (
        <>
            <div data-automation-id="dd-senders-heading" className={classes.senderInfo}>
                <Typography data-automation-id="dd-senders-heading-domain" variant="subtitle1">Sending on behalf of {domainName}</Typography>
                <Typography style={{ color: opacity.black60 }} variant="body1">
                    You can view full details on a sender within My Senders widget.
                    Sender status determines how we process data in EFD.
                </Typography>
            </div>
            <SenderList sendersData={sendersData} onEdit={onEdit}/>
        </>
    );
};

DomainDetailsSendersTab.propTypes = {
    classes: PropTypes.object.isRequired,
    domainName: PropTypes.string,
    onEdit: PropTypes.func.isRequired,
    sendersData: PropTypes.arrayOf( PropTypes.object ),
};

export default withStyles( styles )( DomainDetailsSendersTab );
